module.exports = __webpack_public_path__ + "img/docliniaLogo.dddef8b6.png";